export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 text-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 font-bold text-sm">
                <i className="ri-book-read-line"></i>
              </span>
              <span className="font-heading text-lg text-background-50">亲亲漫画网</span>
            </div>
            <p className="text-sm text-background-300 leading-relaxed">
              亲亲漫画网专注漫画全集免费阅读，提供下拉式全集流畅体验。收录海量完结日漫韩漫大全，支持免费全集下载，一次性看完全部章节，是漫画爱好者的首选在线阅读平台。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-background-100 text-base mb-4">快速导航</h4>
            <nav className="flex flex-col gap-2">
              <a href="#hero" className="text-sm text-background-300 hover:text-background-100 transition-colors cursor-pointer">首页</a>
              <a href="#index" className="text-sm text-background-300 hover:text-background-100 transition-colors cursor-pointer">专题合集</a>
              <a href="#ranking" className="text-sm text-background-300 hover:text-background-100 transition-colors cursor-pointer">热门榜单</a>
              <a href="#updates" className="text-sm text-background-300 hover:text-background-100 transition-colors cursor-pointer">最新更新</a>
              <a href="#faq" className="text-sm text-background-300 hover:text-background-100 transition-colors cursor-pointer">常见问答</a>
            </nav>
          </div>

          <div>
            <h4 className="font-heading text-background-100 text-base mb-4">内容分类</h4>
            <nav className="flex flex-col gap-2">
              <a href="#topics" className="text-sm text-background-300 hover:text-background-100 transition-colors cursor-pointer">日漫全集</a>
              <a href="#topics" className="text-sm text-background-300 hover:text-background-100 transition-colors cursor-pointer">韩漫全集</a>
              <a href="#cards" className="text-sm text-background-300 hover:text-background-100 transition-colors cursor-pointer">完结漫画</a>
              <a href="#carousel" className="text-sm text-background-300 hover:text-background-100 transition-colors cursor-pointer">焦点专题</a>
              <a href="#media" className="text-sm text-background-300 hover:text-background-100 transition-colors cursor-pointer">视频专区</a>
            </nav>
          </div>

          <div>
            <h4 className="font-heading text-background-100 text-base mb-4">合作伙伴</h4>
            <p className="text-sm text-background-400">优质漫画内容合作平台</p>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-400">
            &copy; {new Date().getFullYear()} 亲亲漫画网 - 漫画全集免费在线看
          </p>
          <div className="flex items-center gap-4 text-xs text-background-400">
            <span>漫画全集免费</span>
            <span className="w-1 h-1 rounded-full bg-background-500"></span>
            <span>下拉式全集阅读</span>
            <span className="w-1 h-1 rounded-full bg-background-500"></span>
            <span>完结日漫韩漫大全</span>
          </div>
        </div>
      </div>
    </footer>
  );
}